import React, { useState } from "react";
import { Form, Formik } from "formik";
import PropTypes from "prop-types";
import {useHistory} from 'react-router';

import Toast from "../../../Components/Common/Modules/Toast";
import FormRow from '../../Common/Atoms/Form/FormRow';
import FormCol from '../../Common/Atoms/Form/FormCol';
import InputBox from '../../Common/Atoms/Form/InputBox';
import InputGroup from '../../Common/Atoms/Form/InputGroup';
import Label from '../../Common/Atoms/Form/Label';
import Button from '../../Common/Modules/Button';
import InputFormik from '../../Common/Formik/Input';
import TextareaFormik from '../../Common/Formik/TextArea';
import RadioFormik from '../../Common/Formik/Radio';
import FormBajaSuscripcionesSchema from '../../../Validations/FormBajaSuscripcionesSchema';
import CallbackArticle from '../../../Components/Common/Modules/CallbackArticle';
import InputList from '../../../Components/Common/Atoms/Form/InputsList';
import Paragraph from "../../Common/Atoms/Paragraph";
import CheckboxesMap from '../../../Map/SuscripcionesToInputListMap';
import useSuscripcionesBajaWeb from "../../../Hooks/useSuscripcionesBajaWeb";
import LoadingSpinner from "../../../Helpers/LoadingSpinner";
import ContactoDudasBanner from "../../../Components/Common/Banners/ContactoDudas";
import PathsConfig from "../../../Config/RoutePaths";

const propTypes = { suscripciones: PropTypes.array };

const FormularioSolicitudBaja = (props) => {
    const history = useHistory();
    const { suscripciones, cliente } = props;
    const [dataForm, errorForm, isLoadingForm, solicitarBaja] = useSuscripcionesBajaWeb();
    const [horarioSelected, setHorarioSelected] = useState("");
    const [suscripcionesSelected, setSuscripcionesSelected] = useState([]);
    const [invalid, setInvalid] = useState(false);
    const [invalidHorario, setInvalidHorario] = useState(false);

    const initialValuesFormik = {
        suscripcionesABajar: [],
        telefono: cliente.TelCelular,
        telAlternativo: cliente.TelParticular,
        email: cliente.EMail,
        motivo: "",
        franjaHoraria: horarioSelected
    };

    const handleOnChangeHorario = (event) => {
        const horario = event.target.value;
        setHorarioSelected(horario);
        setInvalidHorario(false);
    };

    const handleCheckedSuscripciones = event => {
        const val = event.target.value;

        let suscripcionSelectedWithprops =
            suscripciones
                .map(suscripcion => {
                    if (suscripcion.IdSuscripcion == val) {
                        return { suscripcionId: suscripcion.IdSuscripcion, nombreAmigable: suscripcion.NombreAmigable };
                    };
                })
                .filter(i => i != undefined);

        if (event.target.checked) {
            setSuscripcionesSelected([...suscripcionesSelected, ...suscripcionSelectedWithprops]);
            setInvalid(false);
        } else {
            const suscripcionesRestantes = suscripcionesSelected.filter(suscripcion => suscripcion.suscripcionId != val);
            setSuscripcionesSelected(suscripcionesRestantes);
            if (!suscripcionesRestantes.length) {
                setInvalid(true);
            }
        };
    };

    const handleValidationsOnSubmit = () => {

        setInvalid(!suscripcionesSelected.length);

        if (horarioSelected === "") {
            setInvalidHorario(true);
        };
    };

    const getFranja = (value) => {
        let matches = value.match(/\D+(\d+)\D+(\d+)/)
        return { inicio: parseInt(matches[1]), fin: parseInt(matches[2]) };
    };

    const onSubmitFormik = async (values, { setSubmitting, setFieldError }) => {
        setSubmitting(true);
        if (!suscripcionesSelected.length) {
            setInvalid(true);
        } else {
            let payload = {
                ...values,
                suscripcionesABajar: suscripcionesSelected,
                franjaHoraria: horarioSelected,
                franjaHorariaInicio: getFranja(horarioSelected).inicio,
                franjaHorariaFin: getFranja(horarioSelected).fin
            };
            solicitarBaja(payload);
        };
        setSubmitting(false);
    };

    const clickCancelar = () => {
		history.push({
			pathname: PathsConfig.MisSuscripciones
		});
	};

    return (
        <Formik
            validationSchema={FormBajaSuscripcionesSchema}
            initialValues={initialValuesFormik}
            onSubmit={onSubmitFormik}
        >
            {() => (
                <LoadingSpinner isLoading={isLoadingForm}>
                    <Form noValidate>
                        {errorForm ? <Toast status="warning" title={errorForm} /> :
                            <>
                                <CallbackArticle
                                    description={
                                        <Paragraph size="--s" mod="--font-bold --arial">Seleccioná las suscripciones en las cuales querés solicitar la baja</Paragraph>
                                    }
                                />
                                <FormRow>
                                    {suscripciones && <InputList
                                        itemsPerPage={0}
                                        hasRowSpacing={true}
                                        label={<Label text="Mis suscripciones" className="--fourxs" />}
                                    >
                                        {CheckboxesMap(suscripciones, handleCheckedSuscripciones, suscripcionesSelected, invalid)}
                                    </InputList>}
                                    {invalid && (<span className="com-input__box__descrip --fivexs --red-500">Seleccioná al menos una suscripción que quieras dar de baja.</span>)}
                                </FormRow>

                                <CallbackArticle
                                    description={
                                        <Paragraph size="--s" mod="--font-bold --arial">Ingresá los datos donde podamos contactarte para gestionar la baja</Paragraph>
                                    }
                                />

                                <FormRow>
                                    <FormCol>
                                        <Label text={"Teléfono de contacto"} />
                                        <InputFormik name="telefono" type="text" description="Código de área y número (Ej: 0117891234)." aria-label="Ingrese su número de teléfono con el código de área"/>
                                    </FormCol>
                                </FormRow>

                                <FormRow>
                                    <FormCol>
                                        <Label text={"Teléfono alternativo"} />
                                        <InputFormik name="telAlternativo" type="text" description="Código de área y número (Ej: 0117891234). Opcional."aria-label="Ingrese un teléfono alternativo (opcional)" />
                                    </FormCol>
                                </FormRow>

                                <FormRow>
                                    <FormCol>
                                        <Label text={"Email de contacto"} />
                                        <InputFormik name="email" type="email" aria-label="Ingrese su email"/>
                                    </FormCol>
                                </FormRow>

                                <FormRow>
                                    <Label text={"Horario de contacto"}/>
                                    <InputGroup className="grid-50-50 state--no-wrap">
                                        <FormCol>
                                            <InputBox
                                                error={invalidHorario}
                                                success={horarioSelected !== ""}
                                                input={
                                                    <RadioFormik
                                                        aria-label="Seleccione horario de 8 a 14"
                                                        onChange={handleOnChangeHorario}
                                                        value={"De 8 a 14"}
                                                        name="franjaHoraria"
                                                        checked={horarioSelected === "De 8 a 14"}
                                                        error={invalidHorario}
                                                        success={horarioSelected !== ""}
                                                    >
                                                        De 8 a 14
                                                    </RadioFormik>
                                                }
                                            />
                                        </FormCol>
                                        <FormCol>
                                            <InputBox
                                                error={invalidHorario}
                                                success={horarioSelected !== ""}
                                                input={
                                                    <RadioFormik
                                                        aria-label="Seleccione horario de 14 a 20"
                                                        onChange={handleOnChangeHorario}
                                                        value={"De 14 a 20"}
                                                        name="franjaHoraria"
                                                        checked={horarioSelected === "De 14 a 20"}
                                                        error={invalidHorario}
                                                        success={horarioSelected !== ""}
                                                    >
                                                        De 14 a 20
                                                    </RadioFormik>
                                                }
                                            />
                                        </FormCol>
                                    </InputGroup>
                                    {invalidHorario && (<span className="com-input__box__descrip --fivexs --red-500">Seleccioná un horario de contacto.</span>)}
                                </FormRow>

                                <FormRow>
                                    <FormCol>
                                        <Label text={"Motivo de la baja"} />
                                        <TextareaFormik name="motivo" rows="7" placeholder="¿Querés agregar una información adicional con el motivo de la baja?" />
                                    </FormCol>
                                </FormRow>

                                <FormRow mod="--btn-groups">
                                    <Button mod="state--mobile-w100" type="submit" label="SOLICITAR BAJA" onClick={handleValidationsOnSubmit} />
                                    <Button href={'#'} mod="state--mobile-w100 --mb-0 --secondary" label="CANCELAR" onClick={clickCancelar} />
                                </FormRow>
                            </>
                        }
                    </Form>
                    <ContactoDudasBanner />
                </LoadingSpinner>
            )}
        </Formik>
    );
};

FormularioSolicitudBaja.propTypes = propTypes;

export default FormularioSolicitudBaja;